import { parseTeamList } from 'app/api/TeamsAPI'
import TeamsConstants from 'constants/TeamsConstants'

class TeamsStore extends Marty.Store {
  state = false
  handlers = {
    teamsFetched: TeamsConstants.FETCH_TEAMS_FINISHED,
    updateTeam: TeamsConstants.UPDATE_TEAM_FINISHED,
  }

  dehydrate() {
    return false
  }

  rehydrate(dehydratedState) {
    if (!!dehydratedState) {
      return parseTeamList(dehydratedState)
    }
    return dehydratedState
  }

  getTeams() {
    return this.fetch({
      id: 'getTeams',
      dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
      locally() {
        if (!!this.state) {
          return this.state
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.actions.TeamsActions.fetchTeamsForOrg(orgId)
      }
    })
  }

  teamsFetched(teams) {
    this.state = teams
  }

  updateTeam(teamId, team) {
    this.state = this.state.set(teamId, team)
  }
}

export default TeamsStore



// WEBPACK FOOTER //
// ./src/scripts/stores/TeamsStore.js